module.exports = __webpack_public_path__ + "static/media/hardik.3ca6604e.jpeg";